import axios from 'axios'
import {
  getToken,
  setToken
} from '@/libs/util'
import {
  Message
} from 'view-design'

axios.defaults.withCredentials = false
class HttpRequest {

  constructor(baseUrl = baseURL) {
    this.baseUrl = baseUrl
    this.queue = {}
  }
  getInsideConfig(options) {
    let token = getToken()
    let authorization = token ? 'Bearer ' + token : ''
    const config = {
      baseURL: this.baseUrl,
      headers: {
        Authorization: authorization // 将本地token写到header中
      }
    }
    if (options.blob) {
      config.responseType = 'blob'
    }
    if (options.headers) {
      config.headers['Content-Type'] = options.headers['Content-Type']
    }
    if (options.form) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    }
    return config
  }
  destroy(url) {
    delete this.queue[url]
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }
  interceptors(instance, url) {
    // 请求拦截
    instance.interceptors.request.use(
      config => {
        // 添加全局的loading...
        if (!Object.keys(this.queue).length) {
          // Spin.show() // 不建议开启，因为界面不友好
        }
        this.queue[url] = true
        return config
      },
      error => {
        return Promise.reject(error)
      }
    )
    // 响应拦截
    instance.interceptors.response.use(
      res => {
        this.destroy(url)
        const {
          data: { code, errorMsg }
        } = res
        if (code !== 0) Message.error(errorMsg)
        return res.data
      },
      error => {
        this.destroy(url)
        let errorInfo = error.response
        console.log('errorInfo', errorInfo)
        if (!errorInfo) {
          const {
            request: {
              statusText,
              status
            },
            config
          } = JSON.parse(JSON.stringify(error))
          errorInfo = {
            statusText,
            status,
            request: {
              responseURL: config.url
            }
          }
        }
        if (error.request.status === 403 && !url.includes('login')) {
          Message.error('登录已过期,请重新登录')
          setTimeout(() => {
            setToken('')
            window.location.href = '/'
          }, 2000)
        }
        return Promise.reject(error)
      }
    )
  }
  request(options) {
    const instance = axios.create()
    options = Object.assign(this.getInsideConfig(options), options)
    this.interceptors(instance, options.url)
    return instance(options)
  }
}
export default HttpRequest